module.exports = __webpack_public_path__ + "static/media/permablok-3.db8b0e30.svg";